import React, { useState, useContext } from 'react'
import './M_Button.css'
import { Tooltip } from '@mui/material'
import { M_Table, M_ElementDrawer, LoadingContext, } from '../../M_Components'
import { t } from 'i18next'

export function M_Button({ onClick, borderColor, backgroundColor, label,
    icon, labelColor, iconPosition, small, none, normal, large, width,
    bold, hoverEffect, tooltip, id, onGetline, FILTER, disable, entity,
    element, errorMessage, tableLabel, height,
    multiple, onSubmitValue, value, valueIdField
}) {

    const [onOpen, setOnOpen] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const ctx = useContext(LoadingContext)

    const divImg = (
        icon && width !== false &&
        // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px', scale: `${small ? '.5' : large ? '1.5' : '1'}` }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px' }}>
            {icon}
        </div>
    )

    const buttonClick = () => {
        if (disable !== undefined && disable !== null) {
            if (disable()) {
                ctx.toastMessages('error', errorMessage, '')
            } else {
                openDrawer()
            }
        } else {
            openDrawer()
        }
    }

    const getLine = (e) => {
        if (multiple) {
            setSelectedRows(e)
        } else {
            onGetline(e[0])
            // onSelectLine(e)
            closeDrawer()
        }
    }

    const openDrawer = () => {
        setOnOpen(true)
    }

    const closeDrawer = () => {
        setOnOpen(false)
    }

    const clickFunction = (event) => {
        if (disable) {
            if (entity || element) {
                return buttonClick()
            }
        } else {
            if (entity || element) {
                return buttonClick()
            } else {
                return onClick(event)
            }
        }
    }

    const onSave = (e) => {
        console.log(e)
        onSubmitValue(e)
        closeDrawer()
    }

    const styledButtons = {
        cursor: 'pointer',
        border: `${borderColor ? `1px solid ${borderColor}` : borderColor}`,
        backgroundColor: backgroundColor,
        padding: `${normal ? '0px 10px' : large ? '5px 15px' : none ? '0px 0px' : width || height ? `${height ? height : 0}px ${width ? width : 0}px` : '0px 5px'}`,
    }

    return (
        <div draggable={false} onDragStart={(event) => event.preventDefault()} id={id}>
            {tooltip ?
                hoverEffect ?
                    <Tooltip onClick={clickFunction} title={tooltip}>
                        <div className='borderButtonDiv2 hoverEffect' style={styledButtons}>
                            {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg : ''}
                            <span style={{ color: labelColor, fontWeight: bold && 'bold' }} className='borderButtonSpan2'> {label} </span>
                            {iconPosition && iconPosition.toUpperCase() === 'RIGHT' && divImg}
                        </div>
                    </Tooltip>
                    :
                    <Tooltip onClick={clickFunction} title={tooltip}>
                        <div className='borderButtonDiv2' style={styledButtons}>
                            {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg : ''}
                            <span style={{ color: labelColor, fontWeight: bold && 'bold' }} className='borderButtonSpan2'> {label} </span>
                            {iconPosition && iconPosition.toUpperCase() === 'RIGHT' && divImg}
                        </div>
                    </Tooltip>
                :
                hoverEffect ?
                    <span onClick={clickFunction} className='borderButtonDiv2 hoverEffect' style={styledButtons}>
                        {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg : ''}
                        {label && <span style={{ color: labelColor, fontWeight: bold && 'bold' }} className='borderButtonSpan2'> {label} </span>}
                        {iconPosition && iconPosition.toUpperCase() === 'RIGHT' && divImg}
                    </span>
                    :
                    <span onClick={clickFunction} className='borderButtonDiv2' style={styledButtons}>
                        {!iconPosition || iconPosition.toUpperCase() === 'LEFT' ? divImg : ''}
                        {label && <span style={{ color: labelColor, fontWeight: bold && 'bold' }} className='borderButtonSpan2'> {label} </span>}
                        {iconPosition && iconPosition.toUpperCase() === 'RIGHT' && divImg}
                    </span>}
            {entity &&
                <M_ElementDrawer
                    element={
                        <div className='divTableDrawer' style={{}}>
                            <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{tableLabel}</h2>
                            <M_Table
                                tableHeight={'70vh'}
                                entityName={entity}
                                useSessionStorage={false}
                                crud={false}
                                onPassLine={getLine}
                                selectSingle={multiple ? false : true}
                                FILTER={FILTER}
                                value={value}
                                valueIdField={valueIdField}
                                extraButtons={multiple && [{ label: t("Save"), element: 'default', icon: <i className="pi pi-save iconTable"></i>, command: (e) => onSave(e) }]}
                            />
                        </div>
                    }
                    tableLabel={tableLabel || ''}
                    entity={entity}
                    open={onOpen}
                    setOpen={setOnOpen}
                    onClose={closeDrawer}
                    onSelectLine={getLine}
                    FILTER={FILTER}
                />}
            {element &&
                <M_ElementDrawer
                    open={onOpen}
                    setOpen={setOnOpen}
                    onClose={closeDrawer}
                    element={element}
                />}
        </div>
    )
}
